<template>
  <div class="register">
    <div class="container">
      <!-- <div class="stepbox">
        <el-steps :active="steptype" simple>
          <el-step title="选择身份" icon="el-icon-user-solid"></el-step>
          <el-step title="信息填写" icon="el-icon-s-claim"></el-step>
          <el-step title="等待审核" icon="el-icon-s-check"></el-step>
        </el-steps>
      </div> -->
      <div class="step" v-if="steptype == 0">
        <div class="registerType">
          <div
            :class="['registerTypeitem', { active: type == 1 }]"
            @click="type = 1"
          >
            <img src="../../assets/02.png" alt="" />
          </div>
          <div
            :class="['registerTypeitem', { active: type == 2 }]"
            @click="type = 2"
          >
            <img src="../../assets/01.png" alt="" />
          </div>
        </div>
        <div class="submitbtn">
          <el-button type="primary" @click="steptype = 1">下一步</el-button>
        </div>
      </div>
      <div class="step" v-if="steptype == 1">
        <div class="team" v-show="type == 1">
          <el-form
            ref="form"
            :rules="dataRule"
            :model="form"
            label-width="120px"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="用户名" prop="userName">
                  <el-input v-model="form.userName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="密码" prop="password">
                  <el-input v-model="form.password" show-password></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="组织类型" prop="type">
                  <el-select v-model="form.type" placeholder="请选组织类型">
                    <el-option label="各级红会" value="1"></el-option>
                    <el-option label="养老机构" value="2"></el-option>
                    <el-option label="志愿者组织" value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="组织名称" prop="realName">
                  <el-input v-model="form.realName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="组织地址" prop="allAddress">
                  <el-cascader
                    ref="myCascader"
                    :props="props"
                    v-model="allAddress"
                    @change="changeAdress"
                  ></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="补充地址" prop="detailedAddress">
                  <el-input v-model="form.detailedAddress"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系人" prop="contacts">
                  <el-input v-model="form.contacts"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系人电话" prop="contactsPhone">
                  <el-input v-model="form.contactsPhone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="身份证号" prop="idnumber">
                  <el-input v-model="form.idnumber"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="电子邮箱" prop="email">
                  <el-input v-model="form.email"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12"
                ><el-form-item label="座机号码" prop="phone">
                  <el-input v-model="form.phone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="组织规模" prop="scale">
                  <el-input v-model="form.scale"></el-input> </el-form-item
              ></el-col>
              <el-col :span="12">
                <el-form-item label="组织标识" prop="logo">
                  <el-upload
                    class="avatar-uploader"
                    :action="
                      baseurl + '/organization/organization/uploadLogoImg'
                    "
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    name="img"
                  >
                    <img
                      v-if="form.logo"
                      :src="baseurl + form.logo"
                      class="avatar"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="相关证书" prop="certificate">
                  <el-upload
                    class="avatar-uploader"
                    :action="
                      baseurl + '/organization/organization/uploadLogoImg'
                    "
                    :show-file-list="false"
                    :on-success="certificatehandleAvatarSuccess"
                    name="img"
                  >
                    <img
                      v-if="form.certificate"
                      :src="baseurl + form.certificate"
                      class="avatar"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item class="submitbtn">
              <el-button type="primary" @click="steptype = 0">上一步</el-button>
              <el-button type="primary" @click="onSubmit">立即申请</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="self" v-show="type == 2">
          <el-form
            ref="selfform"
            :rules="selfdataRule"
            :model="selfform"
            label-width="120px"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="姓名" prop="realName">
                  <el-input v-model="selfform.realName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="身份证号" prop="idnumber">
                  <el-input
                    v-model="selfform.idnumber"
                    @blur="idnumchange"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机号" prop="phone">
                  <el-input v-model="selfform.phone"></el-input> </el-form-item
              ></el-col>
              <el-col :span="12">
                <el-form-item label="密码" prop="password">
                  <el-input
                    v-model="selfform.password"
                    show-password
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="居住地址" prop="allAddress">
                  <el-cascader
                    ref="myCascader"
                    :props="props"
                    v-model="selfform.allAddress"
                    @change="changeAdress"
                  ></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="详细地址" prop="detailedAddress">
                  <el-input v-model="selfform.detailedAddress"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="电子邮箱" prop="email">
                  <el-input v-model="selfform.email"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="性别" prop="sex">
                  <el-radio-group v-model="selfform.sex">
                    <el-radio label="男"></el-radio>
                    <el-radio label="女"></el-radio>
                  </el-radio-group> </el-form-item
              ></el-col>

              <el-col :span="12">
                <el-form-item label="民族" prop="nation">
                  <el-input v-model="selfform.nation"></el-input> </el-form-item
              ></el-col>
              <el-col :span="12">
                <el-form-item label="政治面貌" prop="politics">
                  <el-select
                    v-model="selfform.politics"
                    placeholder="请选政治面貌"
                    clearable
                  >
                    <el-option
                      :label="item"
                      :value="item"
                      :key="item"
                      v-for="item in politicsList"
                    ></el-option>
                  </el-select> </el-form-item
              ></el-col>
              <el-col :span="12">
                <el-form-item label="从事职业" prop="profession">
                  <el-select
                    v-model="selfform.profession"
                    placeholder="请选从事职业"
                    clearable
                  >
                    <el-option
                      :label="item"
                      :value="item"
                      :key="item"
                      v-for="item in professionList"
                    ></el-option>
                  </el-select> </el-form-item
              ></el-col>
              <el-col :span="12">
                <el-form-item label="服务类型" prop="publishId">
                  <el-select
                    v-model="selfform.publishId"
                    multiple
                    placeholder="请选组织类型"
                  >
                    <el-option
                      :label="item.typeName"
                      :value="item.id"
                      :key="item.id"
                      v-for="item in typeList"
                    ></el-option>
                  </el-select> </el-form-item
              ></el-col>

              <el-col :span="12"
                ><el-form-item label="所属志愿服务队" prop="type">
                  <el-select
                    v-model="selfform.organizationId"
                    placeholder="请选所属志愿服务队"
                    clearable
                  >
                    <el-option
                      :label="item.organizationName"
                      :value="item.id"
                      :key="item.id"
                      v-for="item in typeList2"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="个人简介" prop="introduction">
                  <el-input
                    type="textarea"
                    v-model="selfform.introduction"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
                <el-form-item label="头像" prop="header">
                  <el-upload
                    class="avatar-uploader"
                    :action="
                      baseurl + '/organization/organization/uploadLogoImg'
                    "
                    :show-file-list="false"
                    :on-success="headerhandleAvatarSuccess"
                    name="img"
                  >
                    <img
                      v-if="selfform.header"
                      :src="baseurl + selfform.header"
                      class="avatar"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-col> -->
            </el-row>
            <el-form-item class="submitbtn">
              <!-- <el-button type="primary" @click="steptype = 0">上一步</el-button> -->
              <el-button
                type="primary"
                v-if="discriCard(selfform.idnumber) < 16"
                @click="openguardianfrom"
                >添加监护人</el-button
              >
              <el-button type="primary" @click="onSubmit2">立即申请</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="step" v-if="steptype == 2">
        <div class="tips">审核已提交，请等待审核通过...</div>
      </div>
    </div>
    <guardianfromVue
      v-if="addorupdatevisiable"
      ref="guardianfromVue"
      @guardianfrom="getguardianfrom"
    ></guardianfromVue>
  </div>
</template>

<script>
import guardianfromVue from "./guardianfrom.vue";
export default {
  name: "register",
  data() {
    let validatorrealName = (rule, value, callback) => {
      var regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im,
        regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;
      if (!value.trim()) {
        return callback(new Error("必填项不能为空"));
      }
      setTimeout(() => {
        if (regEn.test(value) || regCn.test(value)) {
          return callback(new Error("名称不能包含特殊字符"));
        }
      }, 1000);
    };
    let validatorID = (rule, value, callback) => {
      var regEn = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (!value.trim()) {
        return callback(new Error("必填项不能为空"));
      }
      setTimeout(() => {
        if (!regEn.test(value)) {
          return callback(new Error("身份证格式不正确"));
        }
      }, 1000);
    };
    let validatorphone = (rule, value, callback) => {
      var regEn = /^[1][3,5,7,6,8][0-9]{9}$/;
      if (!value.trim()) {
        return callback(new Error("必填项不能为空"));
      }
      setTimeout(() => {
        if (!regEn.test(value)) {
          return callback(new Error("手机号格式不正确"));
        }
      }, 1000);
    };
    let That = this;
    return {
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          if (level == 0) {
            var params = {
              code: "",
              level: "1",
            };
          } else {
            var params = {
              code: node.value,
              level: level + 1,
            };
          }
          That.$http
            .get(
              `City/city/getAllCity2?code=${params.code}&level=${params.level}`
            )
            .then((res) => {
              if (res.data.code == 0) {
                const nodes = res.data.data.map((item) => ({
                  value: item.criCode,
                  label: item.criName,
                  leaf: parseInt(item.criLevel) - 1 >= 2,
                }));
                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                resolve(nodes);
              }
            });
        },
      },
      selfdataRule: {
        realName: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
          {
            validator: validatorrealName,
            trigger: "blur",
          },
        ],
        idnumber: [
          { required: true, message: "必填项不能为空", trigger: "blur" },
          {
            validator: validatorID,
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "必填项不能为空", trigger: "blur" },

          {
            validator: validatorphone,
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "必填项不能为空", trigger: "blur" },
        ],
        allAddress: [
          { required: true, message: "必填项不能为空", trigger: "change" },
        ],
        email: [
          { required: false, message: "必填项不能为空", trigger: "blur" },
        ],
        sex: [{ required: true, message: "必填项不能为空", trigger: "change" }],
        nation: [
          { required: true, message: "必填项不能为空", trigger: "change" },
        ],
        politics: [
          { required: true, message: "必填项不能为空", trigger: "change" },
        ],
        profession: [
          { required: true, message: "必填项不能为空", trigger: "change" },
        ],
        publishId: [
          { required: true, message: "必填项不能为空", trigger: "change" },
        ],
      },
      dataRule: {
        type: [
          { required: true, message: "必填项不能为空", trigger: "change" },
        ],
        allAddress: [
          { required: true, message: "必填项不能为空", trigger: "blur" },
        ],
        detailedAddress: [
          { required: true, message: "必填项不能为空", trigger: "blur" },
        ],
        realName: [
          { required: true, message: "必填项不能为空", trigger: "blur" },
        ],
        userName: [
          { required: true, message: "必填项不能为空", trigger: "blur" },
        ],
        contacts: [
          { required: true, message: "必填项不能为空", trigger: "blur" },
        ],
        contactsPhone: [
          { required: true, message: "必填项不能为空", trigger: "blur" },
        ],
        idnumber: [
          { required: true, message: "必填项不能为空", trigger: "blur" },
        ],
        password: [
          { required: true, message: "必填项不能为空", trigger: "blur" },
        ],
      },
      baseurl: this.$baseurl,
      type: "2",
      steptype: 1,
      allAddress: [],
      form: {
        type: "",
        realName: "",
        contacts: "",
        contactsPhone: "",
        email: "",
        idnumber: "",
        logo: "",
        password: "",
        phone: "",
        scale: "",
        userName: "",
        detailedAddress: "",
        certificate: "",
      },
      selfform: {
        organizationId: "",
        detailedAddress: "",
        email: "",
        header: "",
        idnumber: "",
        introduction: "",
        nation: "",
        nickname: "",
        type: "",
        password: "",
        phone: "",
        politics: "",
        profession: "",
        publishId: [],
        realName: "",
        sex: "",
        userName: "",
        type: 1,
      },
      typeList: [],
      typeList2: [],
      professionList: ["行政单位", "事业单位", "企业", "其它"],
      politicsList: ["中共党员", "民主党派", "群众", "其它"],
      addorupdatevisiable: false,
      getguardianfromdata: {},
      guardianfromflag: false, //是否填写监护人信息
    };
  },
  components: {
    guardianfromVue,
  },
  mounted() {
    this.gettype();
    this.gettype2();
  },
  methods: {
    getguardianfrom(from) {
      this.guardianfromflag = true;
      this.getguardianfromdata = from;
      this.selfform.organizationId=this.getguardianfromdata.organizationId
    },
    idnumchange() {
      var regEn = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (!this.selfform.idnumber.trim() || !regEn.test(this.selfform.idnumber))
        return false;
      console.log(this.discriCard(this.selfform.idnumber));
      if (this.discriCard(this.selfform.idnumber) < 16) {
        this.$confirm(
          "由于注册志愿者用户未满16岁，需填写监护人信息，点击确认填写监护人信息",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(async () => {
            this.openguardianfrom();
          })
          .catch(() => {});
      }
    },
    // 打开监护人信息弹窗
    openguardianfrom() {
      this.addorupdatevisiable = true;
      this.$nextTick(() => {
        console.log(this.getguardianfromdata);
        this.$refs.guardianfromVue.typeList = this.typeList;
        this.$refs.guardianfromVue.typeList2 = this.typeList2;
        this.$refs.guardianfromVue.selfform = {
          ...this.$refs.guardianfromVue.selfform,
          ...this.getguardianfromdata,
        };
        this.$refs.guardianfromVue.selfform.organizationId =
          this.selfform.organizationId;
        this.$refs.guardianfromVue.init();
      });
    },
    discriCard(UUserCard) {
      (UUserCard + "").substring(6, 10) +
        "-" +
        (UUserCard + "").substring(10, 12) +
        "-" +
        (UUserCard + "").substring(12, 14);
      //获取年龄
      var myDate = new Date();
      var month = myDate.getMonth() + 1;
      var day = myDate.getDate();
      var age = myDate.getFullYear() - (UUserCard + "").substring(6, 10) - 1;
      if (
        (UUserCard + "").substring(10, 12) < month ||
        ((UUserCard + "").substring(10, 12) == month &&
          (UUserCard + "").substring(12, 14) <= day)
      ) {
        age++;
      }
      return age;
    },
    async gettype2() {
      let {
        data: { data, code },
      } = await this.$http.get("/organization/organization/page", {
        params: { page: 1, limit: 10000, status: 2 },
      });
      if (code != 0) return;
      this.typeList2 = data.list;
    },
    async gettype() {
      let {
        data: { data, code },
      } = await this.$http.get("api/publishtype/selectAll");
      if (code != 0) return;
      this.typeList = data;
    },
    headerhandleAvatarSuccess(res, file) {
      console.log(res);
      if (res.code != 0) return;
      this.selfform.header = res.data.logo;
    },
    certificatehandleAvatarSuccess(res, file) {
      console.log(res);
      if (res.code != 0) return;
      this.form.certificate = res.data.logo;
    },
    handleAvatarSuccess(res, file) {
      console.log(res);
      if (res.code != 0) return;
      this.form.logo = res.data.logo;
      console.log(file);
    },
    changeAdress(value) {
      console.log(this.$refs["myCascader"].inputValue);
    },
    async onSubmit() {
      let type = false;
      this.$refs.form.validate((valid) => {
        if (!valid) type = true;
      });
      if (type) return;
      this.form.sheng = this.allAddress[0];
      this.form.shi = this.allAddress[1];
      this.form.qu = this.allAddress[2];
      let {
        data: { code },
      } = await this.$http.post("/organization/organization", this.form);
      if (code != 0) return this.open("申请提交失败!");
      this.steptype = 2;
      this.$router.push("/");
    },
    async onSubmit2() {
      let type = false;
      this.$refs.selfform.validate((valid) => {
        if (!valid) type = true;
      });
      if (type) return;
      if (
        this.discriCard(this.selfform.idnumber) < 16 &&
        !this.guardianfromflag
      )
        return this.$message.warning("填写监护人信息");
      let dataform = JSON.parse(JSON.stringify(this.selfform));
      let guardiandataform = JSON.parse(
        JSON.stringify(this.getguardianfromdata)
      );
      dataform.publishId = dataform.publishId.join();
      dataform.sheng = dataform.allAddress[0];
      dataform.shi = dataform.allAddress[1];
      dataform.qu = dataform.allAddress[2];
      dataform.allAddress = "";
      let datalist = [dataform];
      if (this.discriCard(this.selfform.idnumber) < 16) {
        let guardiandataform = JSON.parse(
          JSON.stringify(this.getguardianfromdata)
        );
        guardiandataform.publishId = guardiandataform.publishId.join();
        guardiandataform.sheng = guardiandataform.allAddress[0];
        guardiandataform.shi = guardiandataform.allAddress[1];
        guardiandataform.qu = guardiandataform.allAddress[2];
        guardiandataform.allAddress = "";
        datalist.push(guardiandataform);
      }

      let {
        data: { code, msg },
      } = await this.$http.post("/volunteer/volunteer", datalist);
      if (code != 0) return this.open(msg ? msg : "申请提交失败!");
      this.steptype = 2;
      this.$router.push("/");
    },
    open(info) {
      this.$alert(info, "提示", {
        confirmButtonText: "确定",
      });
    },
  },
  computed: {},
};
</script>

<style lang="scss">
.register {
  .is-finish {
    color: #de010e;
  }
  .el-button--primary {
    background-color: #de010e;
    border-color: #de010e;
  }
  .el-select,
  .el-cascader {
    width: 100%;
  }
  .step {
    padding-top: 20px;
    .tips {
      background-color: #fff;
      padding: 20px;
    }
  }
  .submitbtn {
    display: flex;
    justify-content: flex-end;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #fff;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border: 2px solid #f0f0f0;
    background-color: #fff;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  background-color: #f0f0f000;
  padding: 30px 0;
  .registerType {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    .registerTypeitem {
      color: #fff;
      font-size: 24px;
      font-weight: 600;
      text-align: center;
      margin: 30px;
      padding: 0;
      cursor: pointer;
      border-radius: 6px;
      overflow: hidden;
      img {
        display: block;
      }
    }
    .active {
      box-shadow: 0px 0px 9px 2px #ffbe76;
    }
  }
}
</style>